import { Box } from '@mui/material'

const ClockLoader = () => {
  return (
    <Box className="loader-bg">
      <Box className="clock-loader"></Box>
    </Box>
  )
}

export default ClockLoader;